import apiClient from './authService';

export const chatService = {
  // Get conversation history with a contact
  getConversationHistory: async (contactId, page = 0, size = 20) => {
    const response = await apiClient.get(`/contacts/${contactId}/messages`, {
      params: {
        page,
        size
      }
    });
    return response.data;
  },

  // Send a message to a contact
  sendMessage: async (contactId, messageContent) => {
    const response = await apiClient.post(`/contacts/${contactId}/messages`, {
      content: messageContent
    });
    return response.data;
  },

  updateChatMode: async (contactId, chatMode) => {
    const response = await apiClient.patch(`/contacts/${contactId}/chat-mode`, {
      chatMode
    });
    return response.data;
  },

  // Get all conversations
  getConversations: async () => {
    const response = await apiClient.get('/messages/conversations');
    return response.data;
  },

  // Get conversation summary for a specific contact
  getConversationSummary: async (contactId) => {
    const response = await apiClient.get(`/messages/conversations/${contactId}`);
    return response.data;
  },

  markConversationRead: async (contactId) => {
    const response = await apiClient.post(`/contacts/${contactId}/messages/read`);
    return response.data;
  }
};

